import ConfirmModal from '../UI/Modal/confirmModal';
import { deleteOrganization } from '../../utils/APIs';
import { useUserContext } from '../../contexts/UserContext';
import { toast } from 'react-toastify';
import { useState } from 'react';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const DeleteOrganizationModal = ({ setSelectedAction, selectedOrganization, setSelectedOrganization, getOrganizations }) => {
    const { userData } = useUserContext();
    const [loading, setLoading] = useState(false);
    const { content } = useContentfulContext();

    const deleteOrg = async () => {
        setLoading(true)
        try {
            const result = await deleteOrganization(userData.token, selectedOrganization.org_token)
            if (result.status) {
                toast.success(result.data.message)
                getOrganizations()
                setSelectedAction('');
                setSelectedOrganization(null)
            }
        } catch (error) {
            console.error('Delete organization error:', error);
        } finally {
            setLoading(false)
        }
    }

    return (
        <ConfirmModal
            title="Delete Organization"
            description={content.ORGANIZATION.delete_modal.description}
            ConfirmText={content.ORGANIZATION.delete_modal.delete_btn}
            loading={loading}
            hideModal={() => setSelectedAction('')}
            handleConfirmation={deleteOrg}
        />
    )
}

export default DeleteOrganizationModal;